import CrudPage from "@/components/CrudPage";

export default function Clients() {
  return (
    <CrudPage
      title="Clients"
      subtitle="Manage dog owners and their contact details."
      endpoint="clients"
      testid="clients"
      detailBase="/clients"
      columns={[
        { key: "full_name", label: "Name", render: (i) => <span className="font-medium">{i.full_name}</span> },
        { key: "email", label: "Email" },
        { key: "phone", label: "Phone" },
        { key: "dog_names", label: "Dogs" },
        { key: "active_bookings", label: "Bookings" },
        { key: "location_name", label: "Location" },
        { key: "status", label: "Status", badge: true },
      ]}
      fields={[
        { name: "full_name", label: "Full name" },
        { name: "email", label: "Email" },
        { name: "phone", label: "Phone" },
        { name: "address", label: "Address" },
        { name: "location_id", label: "Assigned location", type: "select", optionsFrom: "locations", labelKey: "name" },
        { name: "notes", label: "Notes", type: "textarea" },
        { name: "status", label: "Status", type: "select", default: "active", options: [
          { value: "active", label: "Active" }, { value: "inactive", label: "Inactive" },
        ] },
      ]}
    />
  );
}
